<script setup lang="ts">
/** FE-014 — redesign shell; the redirect and the sign-in hand-off are unchanged. */
import { useAuthModal } from "@/features/auth/store";
import router from "@/router";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { FairButton } from "@/ui/primitives/FairButton";

const { t } = useI18n();
const loadingState = ref(false);

function loginHandler() {
  loadingState.value = true;
  useAuthModal().showAuthModal("signIn");
  loadingState.value = false;
}

onMounted(() => {
  router.push({ path: "/" });
});
</script>

<template>
  <div class="fair-auth-status">
    <h2 class="fair-auth-status__title">
      {{ t("signup.registration_success") }}
    </h2>
    <FairButton
      class="fair-auth-form__submit"
      variant="primary"
      size="m"
      :rounded="false"
      :label="t('signup.sign_in_button')"
      :disabled="loadingState"
      @click="loginHandler"
    />
  </div>
</template>
